import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Navbar } from '@/components/generals/navbar'
import { Footer } from '@/components/generals/footer'
import { Motion } from '@/components/generals/motion'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div id='top' className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-[60] rounded-sm bg-coral px-4 py-2 text-sm font-semibold text-charcoal focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <Navbar />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />
            <Motion />
        </div>
    )
}
